"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseObject = parseObject;
exports.stringifyObject = stringifyObject;

var _mapValues2 = _interopRequireDefault(require("lodash/mapValues"));

var _isString2 = _interopRequireDefault(require("lodash/isString"));

var _isPlainObject2 = _interopRequireDefault(require("lodash/isPlainObject"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Export `stringifyObject`.
 */
function stringifyObject(data) {
  function escapeStringValues(value) {
    if ((0, _isString2["default"])(value)) {
      return escape(value);
    }

    if ((0, _isPlainObject2["default"])(value)) {
      return (0, _mapValues2["default"])(value, escapeStringValues);
    }

    return value;
  }

  return escape(JSON.stringify((0, _mapValues2["default"])(data, escapeStringValues)));
}
/**
 * Export `parseObject`.
 */


function parseObject(data) {
  function unescapeStringValues(value) {
    if ((0, _isString2["default"])(value)) {
      return unescape(value);
    }

    if ((0, _isPlainObject2["default"])(value)) {
      return (0, _mapValues2["default"])(value, unescapeStringValues);
    }

    return value;
  }

  return (0, _mapValues2["default"])(JSON.parse(unescape(data)), unescapeStringValues);
}